import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import PipelineViewFilter from "../../../interfaces/pipeline-view-filter";
import {MatDivider} from "@angular/material/list";
import {MatIcon} from "@angular/material/icon";
import {DatePipe} from "@angular/common";
import {MatButtonToggle, MatButtonToggleGroup} from "@angular/material/button-toggle";
import {PipelineFilterConditionType} from "../pipelines-filter-modal/pipelines-filter.service";
import {ActivatedRoute, Router} from "@angular/router";
import {MatDialog} from "@angular/material/dialog";
import {PipelinesShareModalComponent} from "../pipelines-share-modal/pipelines-share-modal.component";
import {PipelinesFilterModalComponent} from "../pipelines-filter-modal/pipelines-filter-modal.component";
import {PipelinesService} from "../../pipelines.service";
import UserPipelinePerm from "../../../interfaces/user-pipeline-permission";
import {ConfirmationModalComponent} from "../../../components/confirmation-modal/confirmation-modal.component";
import {
  ExportModalData,
  PipelinesExportModalComponent
} from "../pipelines-export-modal/pipelines-export-modal.component";
import pipelineView from "../../../interfaces/pipeline-view";
import PipelineFieldFilter from "../../../interfaces/pipeline-field-filter";
import {Subscription} from "rxjs";
import {MatSnackBar, MatSnackBarConfig} from "@angular/material/snack-bar";
import {Person} from "../../../interfaces/person";
import Group from "../../../interfaces/group";

@Component({
  selector: 'pipelines-selection-panel',
  standalone: false,
  templateUrl: './pipelines-selection-panel.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './pipelines-selection-panel.component.scss',
})
export class PipelinesSelectionPanelComponent implements OnInit{
  @Input() globalViews: PipelineViewFilter[]
  @Input() ownedViews: PipelineViewFilter[]
  @Input() sharedViews: UserPipelinePerm[]
  @Input() investorView: UserPipelinePerm[]
  public pipelineReports: {[key:string]: string}[] = []


  public expandedPanels:{[key:string]: boolean} = {
    "global" : true,
    "owned": true,
    "shared": true,
    "investor": true,
    "report": true
  }
  public permissions:any = {}
  fields:PipelineFieldFilter[]|null = null
  dataSub: Subscription;
  public sharedMap: Map<string, string> = new Map<string,string>()
  constructor(private router: Router,  private dialog: MatDialog, private _pipelineService:PipelinesService, private _snackBar: MatSnackBar) {
  }

  ngOnInit() {
    this.pipelineReports = this._getPipelineReports()
    this._pipelineService.currentUser$.subscribe((response:any) => {})
    this.dataSub = this._pipelineService.fieldFilters$.subscribe((fields)=>{
      this.fields=fields;
    })

    this.sharedMap = this._setSharedItem()


  }

  public viewRedirect(pipeline: PipelineViewFilter | { [key: string]: string }){
    let url: string = ''
    if('id' in pipeline && pipeline.id){
      url = '/pipeline/' + pipeline.id
      this.router.navigateByUrl(url)
    } else if('url' in pipeline){
      url = pipeline['url']
      window.open(url, '_blank')
    }
  }

  private _setSharedItem(){
    let pipelines: PipelineViewFilter[] = []

    pipelines = [...this.globalViews, ...this.ownedViews,]

    this.investorView.forEach((view:UserPipelinePerm) => pipelines.push(view.pipeline))
    this.sharedViews.forEach((view:UserPipelinePerm) => pipelines.push(view.pipeline))

    return new Map(
      pipelines.map((item: PipelineViewFilter) => {
        let stringGroup:string[] = []
        const perms = item.acls ?? []
        perms.forEach((perm:any) => {
          if(perm.permissions.length){
            const member: Group| Person = perm.acc.group ?? perm.acc.user.person
            stringGroup.push(member.name)
          }
        })
        return [item.id, stringGroup ? stringGroup.join(', '): '']
      })
    )
  }

  public togglePanel(panel:string){
    this.expandedPanels[panel] = !this.expandedPanels[panel]
  }

  public openShareModal(pipeline: PipelineViewFilter){
    this.dialog.open(PipelinesShareModalComponent, {
      width: '700px',
      data: {
        pipeline: pipeline
      }
    })
  }

  public openEditModal(pipeline: PipelineViewFilter){
    this.dialog.open(PipelinesFilterModalComponent, {
      width: "1000px",
      data : {
        pipeline: pipeline,
      }
    })
  }

  public removePipeline(pipeline: PipelineViewFilter){
    let owner = pipeline.person ? pipeline.person.name : pipeline.relatedGroup.name
    let dialogRef = this.dialog.open(ConfirmationModalComponent, {
      width: '600px',
      data: {
        modalTitle: 'Delete A Pipeline',
        warningMessage: 'Are you sure you want to delete the pipeline?',
        modalInformation: [
          {
            title: "Pipeline",
            info: pipeline.name
          },
          {
            title: "Owner",
            info: owner
          }
        ]
      }
    })
    dialogRef.afterClosed().subscribe((onValue) => {
      if(onValue.clicked === 'Ok'){
        this._pipelineService.deletePipelineFilter(pipeline.id).subscribe({
          next: () =>{
            this._openSnackBar('Pipeline successfully deleted.')
            this._pipelineService.getPipelineViews()
          }
        })
      }
    })
  }

  private _getPipelineReports(){
    return [
      {
        name: "Pricing Tracker",
        url: 'https://app.powerbi.com/groups/me/apps/ef49264e-6a0c-422c-903a-35546a1ffcf8/reports/fe883309-510d-4ceb-9229-badb040fa186/'
      }
    ]
  }
  public openExportModal(pipelineViewFilter?:PipelineViewFilter){
    let data: ExportModalData|null = null;
    if(pipelineViewFilter?.pipelineView && this.fields){
      data={
        fields:this.fields,
        dataStore: {
          pipeline_view_filter_id: pipelineViewFilter.id,
          pipeline_view_id: pipelineViewFilter.pipelineView.id,
          filter:[],
          sort:[],
          group:[]
        },
        currentView: pipelineViewFilter.pipelineView
      }
    }
    if(data) {
      let dialogRef = this.dialog.open(PipelinesExportModalComponent, {
        width: "1000px",
        data
      })
    }
  }

  public _openSnackBar(message:string){
    const config = new MatSnackBarConfig();
    config.panelClass = ['save-success'];
    config.horizontalPosition = "center";
    config.verticalPosition = "top";
    config.duration = 3000;
    this._snackBar.open(message, 'Ok', config);
  }

  ngOnDestroy(){
    this.dataSub?.unsubscribe();
  }
}
